module.exports = __webpack_public_path__ + "img/teacher2_yijian.99701d9f.png";